import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from '@react-pdf/renderer';

// ⬇️ Styles copied and adapted from your example
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
  },
  title: {
    fontSize: 18,
    marginBottom: 10,
    textAlign: 'center',
  },
  sectionTitle: {
    fontSize: 14,
    marginBottom: 8,
    marginTop: 20,
    textDecoration: 'underline',
  },
  infoText: {
    marginBottom: 10,
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 10,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableColHeader: {
    backgroundColor: '#f0f0f0',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    width: '33%',
    padding: 4,
    fontWeight: 'bold',
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    width: '33%',
    padding: 4,
  },
});

const InvitationStatsPDF = ({ fromDate, toDate, data }) => {
  return (
    <Document>
      <Page style={styles.page}>
        <Text style={styles.title}>Invitation Count Report</Text>
        <Text style={styles.infoText}>From: {fromDate}</Text>
        <Text style={styles.infoText}>To: {toDate}</Text>

        <Text style={styles.sectionTitle}>User-wise Count</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={styles.tableColHeader}>#</Text>
            <Text style={styles.tableColHeader}>Sender</Text>
            <Text style={styles.tableColHeader}>Count</Text>
          </View>

          {data.map((item, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={styles.tableCol}>{index + 1}</Text>
              <Text style={styles.tableCol}>{item.name}</Text>
              <Text style={styles.tableCol}>{item.count}</Text>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default InvitationStatsPDF;
